import { motion } from "framer-motion";
import { Crown, Target, Lock, Network } from "lucide-react";

const ITEMS = [
  {
    icon: Crown,
    title: "Founder-led approach",
    body: "Every search is led personally — no juniors, no handoffs.",
  },
  {
    icon: Target,
    title: "Senior operator focus",
    body: "We place the operators who shape outcomes, not headcount.",
  },
  {
    icon: Lock,
    title: "Confidentiality always",
    body: "Discreet retained mandates protected end-to-end.",
  },
  {
    icon: Network,
    title: "Deep network access",
    body: "Curated relationships across the UK leadership market.",
  },
];

export default function TrustBar() {
  return (
    <section
      id="trust"
      data-testid="trust-bar"
      className="relative bg-[#0E2750] border-y border-white/5 py-16 md:py-20"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-px bg-white/5">
          {ITEMS.map((it, i) => {
            const Icon = it.icon;
            return (
              <motion.div
                key={it.title}
                data-testid={`trust-item-${i}`}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-50px" }}
                transition={{ duration: 0.5, delay: i * 0.08 }}
                className="bg-[#0E2750] p-8 md:p-10 group hover:bg-white/[0.02] transition-colors duration-500"
              >
                <Icon
                  size={28}
                  strokeWidth={1.25}
                  className="text-[#C9A876] mb-6 transition-transform duration-500 group-hover:scale-110"
                />
                <h3 className="font-display text-lg md:text-xl text-white tracking-tight mb-2">
                  {it.title}
                </h3>
                <p className="text-sm text-slate-400 leading-relaxed">{it.body}</p>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
